var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildACredit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 631,
    viewBox: "0 0 630 631",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_2344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 630,
    height: 631
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 630,
    height: 631,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_2344)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_2344)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.421 201.212L201.394 300.073C192.312 309.14 192.312 323.841 201.395 332.908L300.421 431.769C309.503 440.836 324.229 440.837 333.311 431.769L432.338 332.909C441.42 323.841 441.42 309.14 432.337 300.073L333.311 201.213C324.229 192.145 309.503 192.145 300.421 201.212Z",
    fill: "#0A1214",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("rect", {
    width: 56.2692,
    height: 56.0916,
    transform: "translate(288.346 287.469)",
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.82 325.005L336.115 331.29L329.816 337.578L332.306 340.055L341.098 331.29L332.306 322.526L329.82 325.005Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.242 325.005L317.947 331.29L324.245 337.578L321.756 340.055L312.964 331.29L321.756 322.526L324.242 325.005Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M330.548 297.986H327.031V312.009H330.548V297.986Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.514 297.986H319.997V312.009H323.514V297.986Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M312.964 312.009H309.447C307.507 312.009 305.93 310.437 305.93 308.503V301.492C305.93 299.558 307.507 297.986 309.447 297.986H312.964C314.903 297.986 316.48 299.558 316.48 301.492V308.503C316.48 310.437 314.903 312.009 312.964 312.009ZM309.447 301.492V308.503H312.964V301.492H309.447Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M302.413 297.986H298.896V312.009H302.413V297.986Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M305.93 336.549H295.379C293.44 336.549 291.863 334.977 291.863 333.043V294.48C291.863 292.547 293.44 290.974 295.379 290.974H334.064C336.004 290.974 337.581 292.547 337.581 294.48V315.515H334.064V294.48H295.379V333.043H305.93V336.549Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.182 202.059L11.2346 309.826C7.54269 313.512 7.54238 319.488 11.2343 323.173L119.181 430.94C122.873 434.625 128.86 434.626 132.552 430.941L240.499 323.174C244.191 319.488 244.19 313.511 240.498 309.825L132.551 202.059C128.86 198.373 122.874 198.374 119.182 202.059Z",
    fill: "white",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.706 240.135L87.5028 310.221C83.8109 313.907 83.8109 319.882 87.5028 323.568L157.706 393.654C161.398 397.339 167.383 397.339 171.075 393.654L241.278 323.568C244.97 319.882 244.97 313.907 241.278 310.221L171.075 240.136C167.383 236.45 161.398 236.45 157.706 240.135Z",
    fill: "#34DBFF",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.182 202.059L11.2346 309.826C7.54269 313.512 7.54238 319.488 11.2343 323.173L119.181 430.94C122.873 434.625 128.86 434.626 132.552 430.941L240.499 323.174C244.191 319.488 244.19 313.511 240.498 309.825L132.551 202.059C128.86 198.373 122.874 198.374 119.182 202.059Z",
    fill: "white",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.706 240.135L87.5028 310.221C83.8109 313.907 83.8109 319.882 87.5028 323.568L157.706 393.654C161.398 397.339 167.383 397.339 171.075 393.654L241.278 323.568C244.97 319.882 244.97 313.907 241.278 310.221L171.075 240.136C167.383 236.45 161.398 236.45 157.706 240.135Z",
    fill: "#34DBFF",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M497.484 202.048L389.536 309.815C385.844 313.5 385.844 319.476 389.536 323.162L497.483 430.928C501.175 434.614 507.162 434.615 510.853 430.929L618.801 323.162C622.493 319.476 622.492 313.499 618.8 309.814L510.853 202.047C507.161 198.362 501.176 198.362 497.484 202.048Z",
    fill: "white",
    stroke: "#0A1214",
    strokeWidth: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M459.725 240.134L389.523 310.219C385.831 313.905 385.83 319.88 389.522 323.566L459.725 393.652C463.417 397.337 469.403 397.337 473.095 393.651L543.298 323.566C546.989 319.88 546.99 313.905 543.298 310.219L473.095 240.133C469.403 236.448 463.417 236.448 459.725 240.134Z",
    fill: "#43FFA8",
    stroke: "#0A1214",
    strokeWidth: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_2344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 616,
    height: 247,
    fill: "white",
    transform: "translate(7 193)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildACredit);
export default __webpack_public_path__ + "static/media/buildACredit.6b822ead0c8ca1b33cb843088528a663.svg";
export { ForwardRef as ReactComponent };